import { FileText } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const EmptyState = ({ icon: Icon = FileText, title, description }) => {
  const { dark } = useTheme();
  return (
    <div style={{ textAlign: 'center', padding: '48px 24px' }}>
      <Icon size={40} color={dark ? '#475569' : '#CBD5E1'} style={{ marginBottom: 12 }} />
      <div style={{ fontSize: 15, fontWeight: 600, color: dark ? '#94A3B8' : '#64748B', marginBottom: 4 }}>{title}</div>
      {description && <div style={{ fontSize: 13, color: dark ? '#64748B' : '#94A3B8' }}>{description}</div>}
    </div>
  );
};

export default EmptyState;
